<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <administrators />
      </div>
    </div>
  </div>
</template>

<script>
import Administrators from "./Administrators";

export default {
  name: "tables",
  components: {
    Administrators,
  },
};
</script>
